import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'



// UPDATE A ROLE
const submit = (userId,payload) => client.put(`auth/updateUser/${userId}`, payload);
export const useUpdateUser = (id,payload) => useMutation(['updateUser',id],() => submit(id,payload))